import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  TextField,
  InputAdornment,
  OutlinedInput,
  IconButton,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import "react-toastify/dist/ReactToastify.css";
import {
  setToken,
  setUserName,
  signInUser,
  verifyEmployee,
} from "../../actions/authActions";
import { useDispatch } from "react-redux";
import { toastMessage } from "../../helper";
import { STRONG_PASSWORD_REGEX } from "../../constants/regexConstants";
import { useTranslation } from "react-i18next";
import { getUserFromURLKey } from "../../services/authService";
import { errorMessage } from "../../constants/messageConstants";
const VerifyEmail = (props: any) => {
  const { t, i18n } = useTranslation();
  const { key } = useParams();
  const inputStyle = {
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "green",
      },
    },
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  if (!key?.length) {
    navigate("/");
  }
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { email, password } = formData;

  const validatePassword = (password: any) => {
    if (!STRONG_PASSWORD_REGEX.test(password)) {
      return errorMessage().STRONG_PASSWORD_REGEX_ERROR;
    }
    return "true";
  };

  const validateForm = () => {
    return (
      email &&
      password?.length >= 8 &&
      validatePassword(password) === "true" &&
      !isLoading
    );
  };
  const onChange = (e: any) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e: any) => {
    e.preventDefault();
    if (validateForm()) {
      verifyEmployee(email, password, key)
        .then((res: any) => {
          if (res?.status) {
            signInUser(email, password, "emailURLActivation", res.accountType)
              .then((res: any) => {
                console.log("user data = ", res);
                localStorage.setItem("userName", email);
                localStorage.setItem("accountType", "Corporate");
                dispatch(setToken(res.data.token));
                if (res.data.token) {
                  navigate("/dashboard");
                } else if (res.data.redirectToPending) {
                  navigate("/coorporate-onboarding");
                } else if (res.data.redirectToOTP) {
                  dispatch(setUserName(email));
                  navigate("/verifyotp", {
                    state: { username: email, password: password },
                  });
                }
              })
              .catch((err: any) => {
                toastMessage(err?.response?.data?.message, "error");
              });
          }
        })
        .catch((err: any) => {
          toastMessage(err?.response?.data?.message, "error");
          navigate("/");
        });
    }
  };

  useEffect(() => {
    getUserFromURLKey(key)
      .then((res: any) => {
        if (res.data.status === "Verified") {
          navigate("/auth/login");
          toastMessage("User already verified", "info");
        } else {
          setFormData({ ...formData, email: res.data.email });
        }
      })
      .catch((err) => {
        navigate("/auth/login");
        toastMessage(err?.response?.data?.message, "error");
        console.log("Error:", err?.response?.data?.message);
      });
  }, []);

  return (
    <form className="pw-width-100 flex flex-col pw-register-form">
      <div className="">
        <div className="flex justify-center flex-col items-center pb-4">
          Welcome! To get started with PlanetWise, please activate your account
          by creating a password.
        </div>
        <div className="pw-input-label">{t("email")}</div>
        <TextField
          type="email"
          variant="outlined"
          placeholder={t("Email Address")}
          size="small"
          name="email"
          className="pw-width-100 pw-input-field"
          value={email}
          onChange={(e) => onChange(e)}
          disabled={true}
        />
      </div>
      <div className="">
        <div className="pw-input-label">{t("password")}</div>
        <OutlinedInput
          id="filled-adornment-password"
          type={showPassword ? "text" : "password"}
          name="password"
          size="small"
          placeholder={t("password")}
          sx={inputStyle}
          className="pw-width-100 pw-input-field"
          value={password}
          onChange={(e) => onChange(e)}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onMouseDown={() => {
                  setShowPassword(true);
                }}
                onClick={() => {
                  setShowPassword(false);
                }}
                edge="end"
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          }
        />
        {password?.length > 0 && validatePassword(password) !== "true" ? (
          <span className="pw-display-error">
            {t(validatePassword(password))}
          </span>
        ) : (
          ""
        )}
      </div>
      <input
        type="submit"
        className={`pw-cursor-pointer ${
          validateForm() ? "pw-primary-button" : "pw-neutral-background"
        }`}
        value={t("Activate")}
        onClick={(e) => onSubmit(e)}
        disabled={!validateForm()}
      />
    </form>
  );
};

export default VerifyEmail;
